import React from 'react';

import Login from 'pages/login';
import ForgotPassword from 'pages/forgot-password';
import UpdatePassword from 'pages/update-password';
import LoginSSO from 'pages/loginSSO';

import UsersList from 'pages/users-list';
import User from 'pages/user';

import Profil from 'pages/profil';
import ProfilsList from 'pages/profils-list';

import Circulation from 'pages/circulation';

import Historisation from 'pages/historisation';
import HistorisationPending from 'pages/historisation-pending';

import CustomersStation from 'pages/customers-station';
import CustomersOD from 'pages/customers-od';

import SendCommunication from 'pages/send-communication';
import SendCommunicationStepTwo from 'pages/send-communication-step-two';
import Confirmation from 'pages/confirmation';

import HelpInfos from 'pages/help-infos';
import HelpInfo from 'pages/help-info';

import CompensationSentences from 'pages/compensation-sentences';
import CompensationSentence from 'pages/compensation-sentence';

import Reasons from 'pages/reasons';
import Reason from 'pages/reason';

import ProductCodes from 'pages/product-codes';
import ProductCode from 'pages/product-code';

import Situations from 'pages/situations';
import Situation from 'pages/situation';

import Masks from 'pages/masks';

import Typologies from 'pages/typologies';
import Typology from 'pages/typology';

import ConstitutionConfigs from 'pages/constitution-configs';
import constitutionConfig from 'pages/constitution-config';

interface RouteConfig {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
  exact?: boolean;
}

// Auth Routes (Public)
export const authRoutes: RouteConfig[] = [
  {
    path: '/login',
    component: Login,
    exact: true,
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    exact: true,
  },
  {
    path: '/update-password',
    component: UpdatePassword,
    exact: true,
  },
  {
    path: '/LoginSSO',
    component: LoginSSO,
    exact: true,
  },
];

// User Management Routes
export const userRoutes: RouteConfig[] = [
  {
    path: '/users',
    component: UsersList,
    exact: true,
  },
  {
    path: '/user/:userName',
    component: User,
    exact: true,
  },
  {
    path: '/user',
    component: User,
    exact: true,
  },
];

// Profile Routes
export const profileRoutes: RouteConfig[] = [
  {
    path: '/profils',
    component: ProfilsList,
    exact: true,
  },
  {
    path: '/profil',
    component: Profil,
    exact: true,
  },
  {
    path: '/profil/:id',
    component: Profil,
    exact: true,
  },
];

// Circulation Routes
export const circulationRoutes: RouteConfig[] = [
  {
    path: '/',
    component: Circulation,
    exact: true,
  },
  {
    path: '/circulation',
    component: Circulation,
    exact: true,
  },
  // TODO: verify id we really use this route
  {
    path: '/circulation/:serviceName/:id',
    component: Circulation,
    exact: true,
  },
];

// History Routes
export const historyRoutes: RouteConfig[] = [
  {
    path: '/historisation',
    component: Historisation,
    exact: true,
  },
  {
    path: '/historisation/:serviceName/:circulationDate',
    component: Historisation,
    exact: true,
  },
  {
    path: '/historisation-pending',
    component: HistorisationPending,
    exact: true,
  },
];

// Customer Routes
export const customerRoutes: RouteConfig[] = [
  {
    path: '/customers/station',
    component: CustomersStation,
    exact: true,
  },
  {
    path: '/customers/OD',
    component: CustomersOD,
    exact: true,
  },
];

// Communication Routes
export const communicationRoutes: RouteConfig[] = [
  {
    path: '/send-communication/:situationCategory',
    component: SendCommunication,
    exact: true,
  },
  {
    path: '/send-communication-step-two/:situationCategory',
    component: SendCommunicationStepTwo,
    exact: true,
  },
  {
    path: '/send-communication-confirmation',
    component: Confirmation,
    exact: true,
  },
];

// Help Info Routes
export const helpInfoRoutes: RouteConfig[] = [
  {
    path: '/help-infos',
    component: HelpInfos,
    exact: true,
  },
  {
    path: '/help-info',
    component: HelpInfo,
    exact: true,
  },
  {
    path: '/help-info/:id',
    component: HelpInfo,
    exact: true,
  },
];

// Admin Routes
export const adminRoutes: RouteConfig[] = [
  // Compensation Sentences
  {
    path: '/compensation-sentences',
    component: CompensationSentences,
    exact: true,
  },
  {
    path: '/compensation-sentence/:id',
    component: CompensationSentence,
    exact: true,
  },
  // Reasons
  {
    path: '/reasons',
    component: Reasons,
    exact: true,
  },
  {
    path: '/reason',
    component: Reason,
    exact: true,
  },
  {
    path: '/reason/:id',
    component: Reason,
    exact: true,
  },
  // Product Codes
  {
    path: '/product-codes',
    component: ProductCodes,
    exact: true,
  },
  {
    path: '/product-code',
    component: ProductCode,
    exact: true,
  },
  {
    path: '/product-code/:id',
    component: ProductCode,
    exact: true,
  },
  // Situations
  {
    path: '/situations',
    component: Situations,
    exact: true,
  },
  {
    path: '/situation',
    component: Situation,
    exact: true,
  },
  {
    path: '/situation/:id',
    component: Situation,
    exact: true,
  },
  // Masks
  {
    path: '/masks',
    component: Masks,
    exact: true,
  },
  // Typologies
  {
    path: '/typologies',
    component: Typologies,
    exact: true,
  },
  {
    path: '/typology',
    component: Typology,
    exact: true,
  },
  {
    path: '/typology/:id',
    component: Typology,
    exact: true,
  },
  // Constitutions
  {
    path: '/constitution',
    component: ConstitutionConfigs,
    exact: true,
  },
  {
    path: '/constitution/:id',
    component: constitutionConfig,
    exact: true,
  },
];
